import Vue from "vue";
import Vuex from "vuex";
import router from "./router";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem("token"),
    userType: localStorage.getItem("userType"),
    userData: {},
    appLoading: false,
    email: null,
    updatedArr: [],
    fullLoc: [],
    eachLoc: null,
    startOrStop: false,
  },
  mutations: {
    SOCKET_() {
      // do something
      console.log("hi");
    },
    loginUser(state, payload) {
      localStorage.setItem("token", payload);
      state.isLoggedIn = true;

      if (state.isLoggedIn == true && state.userType == "AssetAdmin") {
        router.push("/assetAdmin");
      } else if (state.isLoggedIn == true && state.userType == "HostelWarden") {
        router.push("/HostelWarden");
      } else if (
        state.isLoggedIn == true &&
        state.userType == "Hostel Manager"
      ) {
        router.push("/HostelManager");
      } else if (
        state.isLoggedIn == true &&
        state.userType == "viceprincipal"
      ) {
        router.push("/vicePrincipal");
      } else if (
        state.isLoggedIn == true &&
        state.userType != "AssetAdmin" &&
        state.userType != "HostelWarden"
      ) {
        router.push("/admin");
      }
    },
    updateLocation(state, item) {
      state.eachLoc = item;
      // var sum = 0;
      // var arr1 = [],
      //   arr2 = [];
      // arr1.push(item);
      // state.fullLoc.push(item);
      // console.log("Arr1=", arr1);
      // console.log("Arr2=", arr2);
      // console.log("Full Loc=", state.fullLoc);
      // for (let i = 0; i < state.fullLoc.length; i++) {
      //   if (state.fullLoc[i].tripId == item.tripId) {
      //     state.fullLoc[i] = item;
      //     sum++;
      //     if (sum >= 2) state.fullLoc.pop();
      //     console.log(
      //       "updted Lat=",
      //       state.fullLoc[i].lat,
      //       state.fullLoc[i].lon
      //     );

      //   }
      // }

      // // state.updatedArr = state.fullLoc
      // console.log("UpArr store=", state.updatedArr);
    },
    adminbusstartstop(state, item) {
      state.startOrStop=''
      console.log("StoreItem=", item);
      if (item) {
        if (item.isStart) {
          // state.startOrStop = "notstartedtest";
          state.startOrStop = "started";
        } else  {
          // state.startOrStop = "starteduyhe";
          state.startOrStop = "notstarted";
        }
        
        console.log("Startorstop",state.startOrStop)
      }
    },
    logoutUser(state) {
      state.userType = null;
      state.isLoggedIn = false;
      state.userData = {};
      state.initial = "";
      localStorage.removeItem("userType");
      localStorage.removeItem("token");
      localStorage.removeItem('busId')
      localStorage.removeItem('tripId')
      router.push("/loginnew");
    },
    userType(state, payload) {
      state.userType = payload;
      localStorage.setItem("userType", payload);
    },
    userData(state, payload) {
      state.userData = payload;
    },
  },
  actions: {
    SOCKET_() {
      // do something
      alert("Actions");
    },
  },
});
